import { useState } from "react";
import { Alert, Box, Button, Collapse, Grid, IconButton, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export default function EditarDocumentosFactura(props) {
    const factura = { ...props.factura, documentos: new FormData() }
    const [rutaXML, setRutaXML] = useState(false)
    const [rutaPDF, setRutaPDF] = useState(false)
    const [errorDocumentoPDF, setErrorDocumentoPDF] = useState(false)
    const [helperTextDocumentoPDF, setHelperTextDocumentoPDF] = useState('')
    const [errorDocumentoXML, setErrorDocumentoXML] = useState(false)
    const [helperTextDocumentoXML, setHelperTextDocumentoXML] = useState('')
    const [openMensaje, setOpenMensaje] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [severity, setSeverity] = useState('error')
    const cargarDatosTabla = props.cargarDatosTabla

    const handleSubmit = async (e) => {
        e.preventDefault()
        let rutaPDFSinValidar
        let rutaXMLSinValidar
        //console.log(`rutaPDF entrando al handleSubmit ${rutaPDF} ${!Boolean(rutaPDF)}`)
        //console.log(`factura.documentos.get('PDF') ${Boolean(factura.documentos.get('PDF'))}`)
        if (!Boolean(rutaPDF)) {
            const archivoPDF = new FormData();
            if (factura.documentos.get('PDF')) {
                archivoPDF.append('factura', factura.documentos.get('PDF'));
                const resUploadPDF = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                    method: "POST",
                    body: archivoPDF
                })
                rutaPDFSinValidar = (await resUploadPDF.json()).ruta
                //(`rutaPDFSinValidar ${rutaPDFSinValidar}`)
            }
        }
       
            
        if (!Boolean(rutaXML)) {
            const archivoXML = new FormData();
            if (factura.documentos.get('XML')) {
                archivoXML.append('factura', factura.documentos.get('XML'));
                const resUploadXML = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadFacturas`, {
                    method: "POST",
                    body: archivoXML
                })
                rutaXMLSinValidar = (await resUploadXML.json()).ruta
                //console.log(`rutaXMLSinValidar ${rutaXMLSinValidar}`)
            }
        }
        
        //console.log(`rutaPDFSinValidar ${rutaPDFSinValidar}`)    
        //console.log(`factura ${JSON.stringify({id: factura.id, rutaPDF: rutaPDFSinValidar ? rutaPDFSinValidar : rutaPDF, rutaXML: rutaXMLSinValidar ? rutaXMLSinValidar : rutaXML})}`)
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/factura/${factura.id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify({id: factura.id, rutaPDF: rutaPDFSinValidar ? rutaPDFSinValidar : rutaPDF, rutaXML: rutaXMLSinValidar ? rutaXMLSinValidar : rutaXML })
        })
        if(res.status === 200)
            setSeverity('success')
        else
            setSeverity('error')
        const data = await res.json()

        if (data.message) {
            setOpenMensaje(true)
            setMensaje(data.message)
            await cargarDatosTabla()
            return
        }
        else {
            setOpenMensaje(true)
            setMensaje("Se actualizaron los documentos de la factura")
            await cargarDatosTabla()
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                    <>
                        <Grid item xs={12}>
                            <TextField label={'Factura PDF'} id='documentoPDF' name='documentoPDF' focused required type='file' accept="application/pdf" helperText={helperTextDocumentoPDF} error={errorDocumentoPDF} onChange={async (event) => {
                                factura.documentos.delete('PDF')
                                const file = event.target.files[0]
                                if (event.target.value) {
                                    if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf")) {
                                        setHelperTextDocumentoPDF('')
                                        setErrorDocumentoPDF(false)
                                    }
                                    else {
                                        setHelperTextDocumentoPDF('Formato de archivo no válido, se requiere PDF')
                                        setErrorDocumentoPDF(true)
                                        return
                                    }
                                    if (file.size > 5242880) {
                                        setHelperTextDocumentoPDF('El tamaño del archivo debe ser menor a 5MB')
                                        setErrorDocumentoPDF(true)
                                        return
                                    }
                                    else {
                                        setHelperTextDocumentoPDF('')
                                        setErrorDocumentoPDF(false)
                                    }
                                    
                                    setHelperTextDocumentoPDF('')
                                    setErrorDocumentoPDF(false)
                                    let regex = /([^-\w.]*)/gm;
                                    const nombreArchivo = file.name.replace(regex, '');
                                    const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarPDF`, {
                                        method: "GET",
                                        headers: {
                                            "nombre": nombreArchivo,
                                            "carpeta": "facturas"
                                        }
                                    })
                                    if (resVerificar.status === 200) {
                                        //setErrorDocumentoPDF(true)
                                        setHelperTextDocumentoPDF('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                        const data = await resVerificar.json()
                                        //console.log(`data ${data.ruta}`)
                                        setRutaPDF(data.ruta)
                                        //console.log(`rutaPDF ${data.ruta}`)
                                        return
                                    }
                                    else {
                                        setRutaPDF(false)
                                        setErrorDocumentoPDF(false)
                                        setHelperTextDocumentoPDF('')
                                    }
                                }
                                //console.log(`Files[0] ${file.name}`)
                                factura.documentos.append('PDF', file)
                            }} sx={{ width: '100%' }} />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField label='Factura XML' id='documentoXML' name='documentoXML' focused required type='file' accept="application/xml" helperText={helperTextDocumentoXML} error={errorDocumentoXML} onChange={async (event) => {
                                factura.documentos.delete('XML')
                                const file = event.target.files[0]
                                if (event.target.value) {
                                    if (event.target.value.endsWith(".XML") || event.target.value.endsWith(".xml")) {
                                        setHelperTextDocumentoXML('')
                                        setErrorDocumentoXML(false)
                                    }
                                    else {
                                        setHelperTextDocumentoXML('Formato de archivo no válido, se requiere XML')
                                        setErrorDocumentoXML(true)
                                        return
                                    }
                                    if (file.size > 5242880) {
                                        setHelperTextDocumentoXML('El tamaño del archivo debe ser menor a 5MB')
                                        setErrorDocumentoXML(true)
                                        return
                                    }
                                    else {
                                        setHelperTextDocumentoXML('')
                                        setErrorDocumentoXML(false)
                                    }
                                    //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
                                    // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
                                   
                                    setHelperTextDocumentoXML('')
                                    setErrorDocumentoXML(false)
                                    
                                    let regex = /([^-\w.]*)/gm;
                                    const nombreArchivo = file.name.replace(regex, '');
                                    const resVerificar = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/verificarFacturaXML`, {
                                        method: "GET",
                                        headers: {
                                            "nombre": nombreArchivo,
                                            "carpeta": "facturas"
                                        }
                                    })
                                    if (resVerificar.status === 200) {
                                        //setErrorDocumentoXML(true)
                                        setHelperTextDocumentoXML('Ya existe un archivo registrado con ese nombre. Si no lo subiste tú en un intento anterior por favor renombra tu archivo y trata de subirlo de nuevo, de lo contrario se colocará el enlace al archivo existente')
                                        const data = await resVerificar.json()
                                        //console.log(`data ${data.ruta}`)
                                        setRutaXML(data.ruta)
                                        //console.log(`rutaXML ${data.ruta}`)
                                        return
                                    }
                                    else {
                                        setRutaXML(false)
                                        setErrorDocumentoXML(false)
                                        setHelperTextDocumentoXML('')
                                    }
                                }
                                //console.log(`Files[0] ${file.name}`)
                                factura.documentos.append('XML', file)
                            }} sx={{ width: '100%' }} />
                        </Grid>
                    </>
                </Grid>
                <Grid item sx={{ marginTop: 5 }}>
                    <Button variant='contained' color='primary' type='submit' disabled={errorDocumentoPDF || errorDocumentoXML}>
                        Actualizar
                    </Button>
                </Grid>
            </form>

            <Box sx={{ width: '100%' }}>
                <Collapse in={openMensaje}>
                    <Alert severity={severity}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpenMensaje(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        style={{ marginTop: 30 }}
                    >
                        {mensaje}
                    </Alert>
                </Collapse>
            </Box>
        </>
    )
}